import React, { useState, useEffect } from "react";
import { Redirect, Route, useHistory, useLocation } from "react-router-dom";
import axios from "axios";
import swal from "sweetalert";
import Masterlayout from "../src/layouts/admin/Masterlayout";
export default function AdminPrivateRoute({ ...rest }) {
  const [isAuthenticated, setisAuthenticated] = useState(false);
  const [Loading, setLoading] = useState(true);
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    let isMounted = true;

    const token = sessionStorage.getItem("auth_token");
    if (!token) {
      if (isMounted) {
        setisAuthenticated(false);
        setLoading(false);
      }
      return;
    }

    // Response interceptors for authentication errors
    const authInterceptor = axios.interceptors.response.use(
      (response) => response,
      (err) => {
        if (err.response && err.response.status === 401) {
          sessionStorage.removeItem("auth_token");
          localStorage.removeItem("auth_token");
          if (isMounted) {
            setisAuthenticated(false);
          }
          swal("Session Expired", "Please log in to your admin account.", "warning");
          history.replace("/admin/login", { from: location });
        } else if (err.response && err.response.status === 403) {
          swal("Forbidden", err.response.data?.message || "Access Denied", "warning");
          history.push("/403");
        }
        return Promise.reject(err);
      }
    );

    axios
      .get("/api/checkingAuthenticated")
      .then((res) => {
        if (isMounted) {
          if (res.data.status === 200) {
            setisAuthenticated(true);
          } else {
            setisAuthenticated(false);
          }
          setLoading(false);
        }
      })
      .catch(() => {
        if (isMounted) {
          setisAuthenticated(false);
          setLoading(false);
        }
      });

    return () => {
      isMounted = false;
      axios.interceptors.response.eject(authInterceptor);
    };
  }, [history, location]);

  if (Loading) {
    return (
      <div className="d-flex align-items-center justify-content-center" style={{ minHeight: "100vh" }}>
        <div className="spinner-border text-primary" role="status"></div>
      </div>
    );
  }

  return (
    <Route
      {...rest}
      render={(props) => {
        return isAuthenticated ? (
          <Masterlayout {...props} />
        ) : (
          <Redirect to={{ pathname: "/admin/login", state: { from: props.location } }} />
        );
      }}
    />
  );
}
